import { render, staticRenderFns } from "./CustomerConsumption.vue?vue&type=template&id=70f822a8&"
import script from "./CustomerConsumption.vue?vue&type=script&lang=js&"
export * from "./CustomerConsumption.vue?vue&type=script&lang=js&"
import style0 from "./CustomerConsumption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports